module.exports = __webpack_public_path__ + "img/rir-logo-dark.4941b2d5.svg";